import { RoutesWith404 } from '@monorepo/shared/componentsV2/RoutesWith404';
import React from 'react';
import { Route } from 'react-router-dom';
import { RecordsPage } from './components/RecordsPage';

export function RecordsRouter() {
  return (
    <RoutesWith404>
      <Route index element={<RecordsPage />} />
    </RoutesWith404>
  );
}
